import type { ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';
import { Icon } from '../../icon';
import { TagType } from '../enums/TagType';

export const getTagIconByType = (type: TagType, theme: DefaultTheme): ReactNode | undefined => {
  switch (type) {
    case TagType.Success:
      return <Icon $fontSize={theme.typography.fontSize[4]} iconString="circleCheckSolid" />;
    case TagType.Info:
      return <Icon $fontSize={theme.typography.fontSize[4]} iconString="infoSolid" />;
    case TagType.Warning:
      return <Icon $fontSize={theme.typography.fontSize[4]} iconString="diamondExclamationSolid" />;
    case TagType.Error:
      return <Icon $fontSize={theme.typography.fontSize[4]} iconString="triangleExclamationSolid" />;
    case TagType.Basic:
      return <Icon $fontSize={theme.typography.fontSize[4]} iconString="infoSolid" />;
    case TagType.Normal:
      return undefined;
    default:
      return undefined;
  }
};
